export const APPROVE_REQUEST = "APPROVE_REQUEST";
export const DENY_REQUEST = "DENY_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";
export const FETCH_ACCESS_REQUESTS = "FETCH_ACCESS_REQUESTS";
export const FETCH_PENDING_REQUESTS = "FETCH_PENDING_REQUESTS";
export const CATCH_ERROR = "CATCH_ERROR";
export const SET_LOADER = "SET_LOADER";
export const RESET_ACTION = "RESET_ACTION";

export const FETCH_APPLICTION = "FETCH_APPLICTION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const GET_APPLICATION_DETAIL = "GET_APPLICATION_DETAIL";
export const RESET_APPLICATION = "RESET_APPLICATION";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";

export const FETCH_API_INSTANCE = "FETCH_API_INSTANCE";
export const APPLICATION_INSTANCE = "APPLICATION_INSTANCE";
export const GET_SLA_TIERS = "GET_SLA_TIERS";
export const CREATE_REQUEST = "CREATE_REQUEST";
export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const REFETCH_APPLICATION = "REFETCH_APPLICATION";

export const APPROVE_API_REQUEST = "APPROVE_API_REQUEST";
export const DENY_API_REQUEST = "DENY_API_REQUEST";
export const DELETE_API_REQUEST = "DELETE_API_REQUEST";
export const FETCH_SITES = "FETCH_SITES";
export const FETCH_API_GROUPS = "FETCH_API_GROUPS";
export const CATCH_ERROR_SITES = "CATCH_ERROR_SITES";
export const SET_LOADER_SITES = "SET_LOADER_SITES";
export const RESET_ACTION_SITES = "RESET_ACTION_SITES";

export const FETCH_ACCESS_SITES = "FETCH_ACCESS_SITES";